import { Typography, Link } from '@mui/material';
import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import axios from "axios";
import useToken from '../services/token';
import AuthLayout from '../components/AuthLayout';
const Login = () => {
    const { token, removeToken, setToken } = useToken();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    useEffect(() => {
        // Проверяем sessionStorage на наличие сообщения подтверждения
        const emailConfirmed = sessionStorage.getItem('email_confirmed');
        const message = sessionStorage.getItem('confirmation_message');
        if (emailConfirmed) {
            setSnackbarSeverity(emailConfirmed === 'true' ? 'success' : 'error');
            setSnackbarMessage(message || (emailConfirmed === 'true' ? 'Email подтвержден успешно' : 'Ошибка подтверждения email'));
            setOpenSnackbar(true);
            // Очищаем sessionStorage после показа сообщения
            sessionStorage.removeItem('email_confirmed');
            sessionStorage.removeItem('confirmation_message');
        }
    }, []);
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };
    const handleKeyDown = (key) => {
        if (key === 'Enter') {
            sign();
        }
    };
    const sign = () => {
        if ((email == "") && (password == "")) {
            return;
        }
        else {
            let data = new FormData();
            data.append('username', email);
            data.append('password', password);
            axios({
                method: "post",
                url: "/login",
                data: data,
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then(function (response) {
                if (response.data.access_token) {
                    setToken(response.data.access_token);
                    window.location.href = "/";
                }
                if (response.data.message) {
                    setSnackbarSeverity('error');
                    setSnackbarMessage(response.data.message);
                    setOpenSnackbar(true);
                }
            })
                .catch(function (error) {
                setSnackbarSeverity('error');
                setSnackbarMessage("Произошла ошибка при входе");
                setOpenSnackbar(true);
            });
        }
    };
    return (React.createElement(AuthLayout, { snackbarOpen: openSnackbar, snackbarMessage: snackbarMessage, snackbarSeverity: snackbarSeverity, onCloseSnackbar: handleCloseSnackbar },
        React.createElement("div", { style: { marginBottom: '30px' } },
            React.createElement("div", null,
                React.createElement("div", { style: { marginBottom: '30px' } },
                    React.createElement(Typography, { variant: 'body1' }, "\u0412\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0432\u0445\u043E\u0434, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438.")),
                React.createElement("div", null,
                    React.createElement(Stack, { spacing: 1 },
                        React.createElement(TextField, { required: true, id: "outlined-required", label: "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430", onChange: (e) => setEmail(e.target.value), onKeyDown: (e) => handleKeyDown(e.key) }),
                        React.createElement(TextField, { required: true, id: "outlined-password-input", label: "\u041F\u0430\u0440\u043E\u043B\u044C", type: "password", autoComplete: "current-password", onKeyDown: (e) => handleKeyDown(e.key), onChange: (e) => setPassword(e.target.value) })),
                    React.createElement("div", { className: "submitMargin" },
                        React.createElement(Button, { onClick: () => sign(), variant: "contained" }, "\u0412\u0445\u043E\u0434")),
                    React.createElement("div", { style: { marginTop: '20px' } },
                        React.createElement(Typography, { variant: 'body2' },
                            "\u041D\u0435\u0442 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438?",
                            ' ',
                            React.createElement(Link, { href: "/register", style: { cursor: 'pointer' } }, "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F"))),
                    React.createElement("div", { style: { marginTop: '10px' } },
                        React.createElement(Typography, { variant: 'body2' },
                            React.createElement(Link, { href: "/forgot-password", style: { cursor: 'pointer' } }, "\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?"))))))));
};
export default Login;
